"use-strict";

import { Lazy } from './Lazy';
import { Helpers } from './Helpers';

import 'jquery';

export class Modal{
    terms = document.getElementById('terms');
    termsPage = document.getElementById('section-terms');
    closeTerms = document.getElementById('close-terms');
    portfolio = document.getElementsByClassName('portfolio-item');
    modal;
    spinner;
    closePortfolio = document.getElementById('close-modal-button');
    baseTitle = 'Arquitetura e Engenharia | Edifier';
    baseDesc = document.head.querySelector('meta[name="description"]').content;
    constructor(){
        this.init();
        this.initPortfolio();
    }

    showModal() {
        this.modal.classList.add('portfolio-modal-show');
        this.spinner.classList.add('spinner-flex');
    }

    hideModal() {
        this.removeMetaTags();
        this.modal.classList.remove('portfolio-modal-show');
        this.spinner.classList.add('spinner-flex');
    }

    getServicesRelatedIcons(services) {
        let html = '';
        services.forEach(el => {
            html = html + `
                <img src="${window.location.origin + '/storage/' + el.icon}" class="service-icon">
            `;
        });
        return html;
    }

    getServicesRelated(services) {
        let html = 'Serviços desenvolvidos: ';
        services.forEach((el, i) => {
            html = html + `${el.name}${i + 1 < services.length ? ', ' : '.'} `;
        })

        return html;
    }

    getModalHtml(el) {
        const icons = this.getServicesRelatedIcons(el.related_services);
        const services = this.getServicesRelated(el.related_services);
        return `
            <img class="featured-image"
                src="${el.featured_image.url}">
            <div class="modal-text">
                <h2 class="title">
                    ${el.name}
                </h2>
                <div class="text">
                    ${el.content}
                </div>

                <div class="services-related-icons">
                    ${icons}
                </div>
                <div class="services-related">${services}</div>
            </div>
        `;
    }

    applyResponse(res) {
        $(this.spinner).removeClass('spinner-flex');
        document.getElementById('modal-content').innerHTML = this.getModalHtml(res);
        setTimeout(() => {
            const lazy = new Lazy('b-lazy-modal', [{width: 320, src: 'data-src'}]);
        }, 300)
    }

    async applyMetaTags(item) {
        let title = `${item.name} | ${this.baseTitle}`;
        document.title = title;
        document.head.querySelector('meta[name="description"]').content = Helpers.stripTags(item.content);
        window.history.pushState({'pageTitle': title}, title, `${window.location.origin}/portfolio/${item.slug}`);
    }

    async removeMetaTags() {
        document.title = this.baseTitle;
        document.head.querySelector('meta[name="description"]').content = this.baseDesc;
        window.history.pushState({'pageTitle': this.baseTitle}, this.baseTitle, window.location.origin);
    }

    portfolioItemEvent(ev) {
        ev.preventDefault();
        const route = ev.target.dataset.route;
        if (route !== null && route !== undefined) {
            this.showModal();
            $.get(route).then(res => {
                this.applyMetaTags(res);
                this.applyResponse(res);
            });
        }
    }

    applyHoverEffects(index) {
        Array.from(this.portfolio).forEach((element, i) => {
            if (i === index) {
                element.classList.add('hover-effect-color');
            } else {
                element.classList.add('hover-effect-gray');
            }
        })

    }

    removeHoverEffects(index) {
        Array.from(this.portfolio).forEach((element, i) => {
            if (i === index) {
                element.classList.remove('hover-effect-color');
            } else {
                element.classList.remove('hover-effect-gray');
            }
        })
    }

    createPortfolioEvents() {
        if (this.portfolio.length > 0) {
            Array.from(this.portfolio).forEach((element, index) => {
                element.addEventListener('click', (ev) => this.portfolioItemEvent(ev));
                element.addEventListener('mouseover', () => this.applyHoverEffects(index));
                element.addEventListener('mouseleave', () => this.removeHoverEffects(index));
            });
        }
    }

    initPortfolio() {
        this.modal = document.getElementById('modal-section');
        this.spinner = document.getElementById('modal-spinner');
        if (this.closePortfolio !== null && this.portfolio !== undefined) {
            this.closePortfolio.addEventListener('click', () => {
                this.hideModal();
            })
        }
        if (this.portfolio !== null && this.portfolio !== undefined) {
            this.createPortfolioEvents();
        }

        if (window.portItem !== null && window.portItem !== undefined) {
            this.showModal();
            this.applyMetaTags(window.portItem);
            this.applyResponse(window.portItem);
        }
    }

    init() {
        if (this.terms !== null && this.terms !== undefined && this.termsPage !== null && this.termsPage !== undefined) {
            this.terms.addEventListener('click', (ev) => {
                this.termsPage.classList.add('terms--open');
            });
            this.closeTerms.addEventListener('click', (ev) => {
                setTimeout(() => {
                    this.termsPage.classList.remove('terms--open');
                    this.termsPage.classList.remove('terms--closing');
                }, 1001);
                this.termsPage.classList.add('terms--closing');
            });
        }
    }

}
